// extracted by mini-css-extract-plugin
module.exports = {"ageBlockContainer":"styles_ageBlockContainer__t2zkm"};